const glossaryAds = [
  {
    term: 'Total Tracked Ads',
    id: 1,
    termId: 1,
    definition: 'Number of ads processed by IAS.',
    hierarchy: 1,
    formula: '[Fraud + Measured + Unmeasured]',
    tag: 'Ads',
  },
  {
    term: 'VALID TRAFFIC',
    id: 135,
    termId: 135,
    definition: 'The number of ads that IAS did not detect as invalid traffic.',
    hierarchy: 1,
    formula: '[Fraud + Measured + Unmeasured]',
    tag: 'Ads',
  },
  {
    term: 'Blocked Ads',
    id: 2,
    termId: 2,
    definition:
      'Number of ads blocked for brand safety reasons. This number is a subset of total ads marked as failed for violating buy-side settings.',
    hierarchy: 1,
    formula: '',
    tag: 'Ads',
  },
  {
    term: 'Invalid Traffic (IVT) Ads',
    id: 3,
    termId: 3,
    definition: 'Number of ads that IAS identifies as invalid traffic.',
    hierarchy: 1,
    formula: '',
    tag: 'Ads',
  },
  {
    term: 'Measured Ads',
    id: 4,
    termId: 4,
    definition: 'Number of ads for which we are able to collect viewability data.',
    hierarchy: 1,
    formula: '[ In­View + Out­of­View + Suspicious Impressions ]',
    tag: 'Ads',
  },
  {
    term: 'Viewable Impressions',
    id: 5,
    termId: 5,
    definition:
      'Number of unblocked viewable impressions in a campaign with all detected invalid traffic removed, where at least 50% of the ad is in view for 1 continuous second for display (2 continuous seconds for video) and at least 1 pixel of the creative rendered on screen. A 30% or more rule applies to large creative that are at least 242,500 pixels.',
    hierarchy: 1,
    formula: '',
    tag: 'Ads',
  },
  {
    term: 'Out-of-View Ads',
    id: 6,
    termId: 6,
    definition:
      'Number of ads in a campaign with all invalid traffic removed that did not meet the viewability requirements.',
    hierarchy: 1,
    formula: '',
    tag: 'Ads',
  },
  {
    term: 'Unmeasured Ads',
    id: 7,
    termId: 7,
    definition:
      'Number of ads in a campaign that are not blocked but for which we are unable to make a viewability or invalid traffic measurement.',
    hierarchy: 1,
    formula: '',
    tag: 'Ads',
  },
  {
    term: 'Discrepancy-Free Ads',
    id: 8,
    termId: 8,
    definition:
      'Number of ads where there is an IAS pixel in the creative (advertiser or agency) and an IAS pixel on the page (publisher) and the pixels load and interact with each other.',
    hierarchy: 1,
    formula: '',
    tag: 'Ads',
  },
  {
    term: 'Refreshed Ads',
    id: 82,
    termId: 78,
    definition: 'Number of ads where an ad slot was refreshed.',
    hierarchy: 1,
    formula: null,
    tag: 'Ads',
  },
  {
    term: 'Impressions (Rendered)',
    id: 86,
    termId: 81,
    definition:
      'An ad can be considered an impression only if IAS has confirmed it to have begun to render. An ad is considered rendered when the creative has begun to load in the browser.',
    hierarchy: 1,
    formula: null,
    tag: 'Ads',
  },
  {
    term: 'IAS Refreshed Ads',
    id: 90,
    termId: 86,
    definition:
      'Number of ads where an ad slot was refreshed based on the MRC definition of "in-view" for a given duration.',
    hierarchy: 1,
    formula: null,
    tag: 'Ads',
  },
  {
    term: 'Eligible Ads For Viewability Measurement',
    id: 110,
    termId: 106,
    definition:
      'The total number of ads which are eligible for measuring viewability-related metrics.',
    hierarchy: 1,
    formula: null,
    tag: 'Ads',
  },
  {
    term: 'Viewable Ads',
    id: 136,
    termId: 136,
    definition:
      'Number of viewable ads in a campaign where at least 50% of the ad is in view for a continuous time of at least 1 second (2 seconds for video) as per IAB Standards. Per updated MRC guidance, a 30% or more rule applies to large creative that are at least 242,500 pixels.',
    hierarchy: 1,
    formula: null,
    tag: 'Ads',
  },
];

const glossaryRates = [
  {
    term: 'Blocked Rate',
    id: 9,
    termId: 9,
    definition: 'Percentage of ads blocked for brand safety reasons.',
    hierarchy: 1,
    formula: '[SUM(blockedImps) / SUM(totalImps)) * 100]',
    tag: 'Rates',
  },
  {
    term: 'Measured Rate',
    id: 10,
    termId: 10,
    definition:
      'Measured ads as a percentage of total unblocked ads with all invalid traffic removed.',
    hierarchy: 1,
    formula: '[ (In View + Out of View ) / Total Impressions ]',
    tag: 'Rates',
  },
  {
    term: 'Invalid Traffic Rate',
    id: 11,
    termId: 11,
    definition:
      'Percentage of ads that IAS identified as invalid traffic, out of all ads processed by IAS.',
    hierarchy: 1,
    formula: '[suspicous impressions/ Total impressions]',
    tag: 'Rates',
  },
  {
    term: 'Viewable Rate (Out Of Measured Ads)',
    id: 12,
    termId: 12,
    definition:
      'Viewable impressions as a percentage of measured ads with all invalid traffic removed.',
    hierarchy: 1,
    formula: '[ In View Impressions / ( In View + Out of View ) ]',
    tag: 'Rates',
  },
  {
    term: 'Discrepancy-Free Rate',
    id: 13,
    termId: 13,
    definition: 'Discrepancy free ads as a percentage of total ads.',
    hierarchy: 1,
    formula: 'disc free imps / total imps',
    tag: 'Rates',
  },
  {
    term: 'Unmeasured Rate',
    id: 14,
    termId: 14,
    definition:
      'Unmeasured ads as a percentage of total tracked ads with all invalid traffic removed.',
    hierarchy: 1,
    formula: '[ Unmeasured Impressions / Total Unblocked Impressions ]',
    tag: 'Rates',
  },
  {
    term: 'Refreshed Ad Rate',
    id: 84,
    termId: 79,
    definition: 'Refreshed ads as a percentage of total tracked ads.',
    hierarchy: 1,
    formula: null,
    tag: 'Rates',
  },
  {
    term: 'Rendered Rate',
    id: 87,
    termId: 82,
    definition: 'The percentage of impressions (rendered) out of total tracked ads.',
    hierarchy: 1,
    formula: null,
    tag: 'Rates',
  },
  {
    term: 'IAS Refreshed Ad Rate',
    id: 91,
    termId: 87,
    definition: 'IAS refreshed ads as a percentage of total tracked ads.',
    hierarchy: 1,
    formula: null,
    tag: 'Rates',
  },
];

const glossaryInvalidTraffic = [
  {
    term: 'GIVT (General Invalid Traffic) Rate',
    id: 72,
    termId: 68,
    definition:
      'The percentage of ads that IAS detected as GIVT, out of all ads processed by IAS. Traffic that failed to meet ad quality criteria filtered through and caught by known IP and bot lists (ex: google web crawlers).',
    hierarchy: 1,
    formula: null,
    tag: 'Invalid Traffic',
  },
  {
    term: 'GIVT (General Invalid Traffic) Ads',
    id: 73,
    termId: 69,
    definition:
      'The number of ads that IAS detected as GIVT. Traffic that failed to meet ad quality criteria filtered through and caught by known IP and bot lists (ex: google web crawlers).',
    hierarchy: 1,
    formula: null,
    tag: 'Invalid Traffic',
  },
  {
    term: 'Bots SIVT (Sophisticated Invalid Traffic) Rate',
    id: 74,
    termId: 70,
    definition:
      'The percentage of ads that IAS detected as bots, out of all ads processed by IAS. A malicious software application that runs automated tasks over the internet, usually to make a profit by falsely mimicking real human activity.',
    hierarchy: 1,
    formula: null,
    tag: 'Invalid Traffic',
  },
  {
    term: 'Bots SIVT (Sophisticated Invalid Traffic) Ads',
    id: 75,
    termId: 71,
    definition:
      'The number of ads that IAS detected as bots. A malicious software application that runs automated tasks over the internet, usually to make a profit by falsely mimicking real human activity.',
    hierarchy: 1,
    formula: null,
    tag: 'Invalid Traffic',
  },
  {
    term: 'Hidden Ads SIVT (Sophisticated Invalid Traffic) Rate',
    id: 76,
    termId: 72,
    definition:
      'The percentage of ads that IAS detected as Hidden Ads (SIVT), out of all ads processed by IAS. Ads that have no chance of ever being seen by humans. Types of hidden ads include: pixel stuffing, ad stacking, ads clipped by iframes, zero opacity ads, off-page ads, ad truncation, and hidden ads embedded in ads.',
    hierarchy: 1,
    formula: null,
    tag: 'Invalid Traffic',
  },
  {
    term: 'Hidden Ads SIVT (Sophisticated Invalid Traffic)',
    id: 77,
    termId: 73,
    definition:
      'The number of ads that IAS detected as Hidden Ads (SIVT). Ads that have no chance of ever being seen by humans. Types of hidden ads include: pixel stuffing, ad stacking, ads clipped by iframes, zero opacity ads, off-page ads, ad truncation, and hidden ads embedded in ads.',
    hierarchy: 1,
    formula: null,
    tag: 'Invalid Traffic',
  },
  {
    term: 'Incentivized browsing RVI (Reduced Value Inventory) Rate',
    id: 78,
    termId: 74,
    definition:
      'The percentage of ads that IAS detected as Incentivized Browsing (RVI), out of all ads processed by IAS. The act of generating traffic and/or engaging with ads on ad-supported sites by human users, in exchange for payment of some other, typically financial, benefit.',
    hierarchy: 1,
    formula: null,
    tag: 'Invalid Traffic',
  },
  {
    term: 'Incentivized browsing RVI (Reduced Value Inventory) Ads',
    id: 79,
    termId: 75,
    definition:
      'The number of ads that IAS detected as Incentivized Browsing (RVI). The act of generating traffic and/or engaging with ads on ad-supported sites by human users, in exchange for payment of some other, typically financial, benefit.',
    hierarchy: 1,
    formula: null,
    tag: 'Invalid Traffic',
  },
  {
    term: 'Proxy Servers RVI (Reduced Value Inventory) Rate',
    id: 80,
    termId: 76,
    definition:
      'The percentage of ads that IAS detected as Proxy Servers (RVI), out of all ads processed by IAS. A computer network service that uses indirect network connections to sometimes enable bots to hide their true identity and location.',
    hierarchy: 1,
    formula: null,
    tag: 'Invalid Traffic',
  },
  {
    term: 'Proxy Servers RVI (Reduced Value Inventory) Ads',
    id: 81,
    termId: 77,
    definition:
      'The number of ads that IAS detected as Proxy Servers (RVI). A computer network service that uses indirect network connections to sometimes enable bots to hide their true identity and location.',
    hierarchy: 1,
    formula: null,
    tag: 'Invalid Traffic',
  },
  {
    term: 'Domain Spoofing SIVT (Sophisticated Invalid Traffic)',
    id: 89,
    termId: 85,
    definition:
      'Ads that are low quality inventory disguised as high-quality legitimate-sites, or send incorrect referrer information to hide their identity.',
    hierarchy: 1,
    formula: null,
    tag: 'Invalid Traffic',
  },
  {
    term: 'Reduced Value Inventory (RVI) Ads',
    id: 108,
    termId: 104,
    definition:
      'The total number of ads that IAS detected as Reduced Value Inventory Ads. Proxy Server Ads + Incentivised Browsing Ads = Reduced Value Inventory Ads',
    hierarchy: 1,
    formula: null,
    tag: 'Invalid Traffic',
  },
  {
    term: 'Sophisticated Invalid Traffic (SIVT) Ads',
    id: 109,
    termId: 105,
    definition: 'The total number of ads that IAS detected as Sophisticated Invalid Traffic Ads.',
    hierarchy: 1,
    formula: null,
    tag: 'Invalid Traffic',
  },
];

const glossaryBots = [
  {
    term: 'Sitting Ducks',
    id: 24,
    termId: 24,
    definition:
      'These bots typically reside on end-user devices. Detection avoidance is mostly pursued through aggressive use of traffic-filtering services falsely claiming to defeat invalid traffic prevention services.',
    hierarchy: 1,
    formula: '',
    tag: 'Bots',
  },
  {
    term: 'Standard Bots',
    id: 25,
    termId: 25,
    definition:
      'Standard bots include many common strains of IE-based malware, residing primarily on residential devices. They will often use multiple concurrent browser sessions, resulting in a proliferation of short-lived targeting profiles. Their focus is on scale rather than compiling cookies or evading detection.',
    hierarchy: 1,
    formula: '',
    tag: 'Bots',
  },
  {
    term: 'Volunteer Bots',
    id: 26,
    termId: 26,
    definition:
      "Volunteer bots frequently reside in cloud services, allowing 24/7 operation and eliminating load on the operator's own machine. They also implement basic detection-evasion measures such as user agent spoofing. Most popular within the US.",
    hierarchy: 1,
    formula: '',
    tag: 'Bots',
  },
  {
    term: 'Profile Bots',
    id: 27,
    termId: 27,
    definition:
      'Bots focused on developing valuable user profiles by spending time on premium sites. They protect this investment by attempting to evade detection through user agent spoofing and use of public proxy servers and are often Webkit-based.',
    hierarchy: 1,
    formula: '',
    tag: 'Bots',
  },
  {
    term: 'Masked Bots',
    id: 28,
    termId: 28,
    definition:
      'Bots that go to great lengths to evade detection and obscure their activity. Numerous aspects of the browser environment, including user agent, installed plugins, and browser geometry are manipulated. Premium publishers can face two dangers as the bots build user profiles as well as perform domain spoofing.',
    hierarchy: 1,
    formula: '',
    tag: 'Bots',
  },
  {
    term: 'Nomadic Bots',
    id: 29,
    termId: 29,
    definition:
      'Bots that frequently use proxy servers or VPNs to hide their true network location. Nomadic bots are similar to basic bots, but are difficult to track with typical user identification techniques. Frequently found with European IP addresses.',
    hierarchy: 1,
    formula: '',
    tag: 'Bots',
  },
  {
    term: 'Other Bots',
    id: 30,
    termId: 30,
    definition:
      'Other invalid traffic, including uncommon types of non-human traffic as well as ads hidden by publisher-side techniques such as ad stacking.',
    hierarchy: 1,
    formula: '',
    tag: 'Bots',
  },
];

const glossaryVideo = [
  {
    term: '% in View',
    id: 51,
    termId: 51,
    definition:
      'Percentage of ads where 50% or more of the ad creative is in view for a minimum of 2 seconds (3MS standard).',
    hierarchy: 1,
    formula: '',
    tag: 'Video',
  },
  {
    term: '% Out of View',
    id: 52,
    termId: 52,
    definition:
      'Percentage of ads in a campaign that are in view for less than two seconds, or were invalid unblocked ads.',
    hierarchy: 1,
    formula: '',
    tag: 'Video',
  },
  {
    term: '% Ad Never Started',
    id: 53,
    termId: 53,
    definition: 'Percentage of ads where an ad loaded but never started.',
    hierarchy: 1,
    formula: '',
    tag: 'Video',
  },
  {
    term: '% Completed',
    id: 54,
    termId: 54,
    definition: 'Percentage of the video that is complete. ',
    hierarchy: 1,
    formula: '',
    tag: 'Video',
  },
  {
    term: '% Completed In View',
    id: 55,
    termId: 55,
    definition:
      'Percentage of ads within a campaign where the ad is 100% complete and more than 50% of the ad creative is in view. ',
    hierarchy: 1,
    formula: '',
    tag: 'Video',
  },
  {
    term: '% Muted',
    id: 56,
    termId: 56,
    definition: 'Percentage of ads in a campaign that are on mute for one or more seconds.',
    hierarchy: 1,
    formula: '',
    tag: 'Video',
  },
  {
    term: '% Full Screen',
    id: 57,
    termId: 57,
    definition: 'Percentage of ads where a video ad expands to full screen for one second or more.',
    hierarchy: 1,
    formula: '',
    tag: 'Video',
  },
  {
    term: 'CTR (Click-Thru Rate)',
    id: 58,
    termId: 58,
    definition:
      'Percentage of ads in a campaign where a video ad is clicked through to an external URL.',
    hierarchy: 1,
    formula: '',
    tag: 'Video',
  },
  {
    term: 'First Quartile Ads',
    id: 111,
    termId: 107,
    definition: 'Number of video ads that played to 25% of video length with no IVT',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'First Quartile Rate (% Of Valid Video Ads)',
    id: 112,
    termId: 108,
    definition: 'The percentage of First Quartile Ads out of Valid Video Ads.',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'Second Quartile Ads',
    id: 113,
    termId: 109,
    definition: 'umber of video ads that played to 50% of video length with no IVT',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'SECOND QUARTILE RATE (% OF VALID VIDEO ADS)',
    id: 114,
    termId: 110,
    definition: 'The percentage of Second Quartile Ads out of Valid Video Ads.',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'THIRD QUARTILE ADS',
    id: 115,
    termId: 111,
    definition: 'Number of video ads that played to 75% of video length with no IVT',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'THIRD QUARTILE RATE (% OF VALID VIDEO ADS)',
    id: 116,
    termId: 112,
    definition: 'The percentage of Third Quartile Ads out of Valid Video Ads.',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'COMPLETED ADS',
    id: 117,
    termId: 113,
    definition: 'Number of video ads that played to completion with no IVT',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'COMPLETION RATE (% OF VALID VIDEO ADS)',
    id: 118,
    termId: 114,
    definition: 'The percentage of Completed Ads out of Valid Video Ads.',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'Valid video Ads',
    id: 119,
    termId: 115,
    definition: 'Video ads with no IVT',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'Valid Viewable Video Ads',
    id: 120,
    termId: 116,
    definition: 'The number of Viewable Video Ads with all IVT removed.',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'Viewable First Quartile Ads',
    id: 121,
    termId: 117,
    definition:
      'Number of video ads that were in view and played to 25% of video length. Excludes video ads marked as IVT.',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'Viewable Second Quartile Ads',
    id: 122,
    termId: 118,
    definition:
      'Number of video ads that were in view and played to 50% of video length. Excludes video ads marked as IVT.',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'Viewable Third Quartile Ads',
    id: 123,
    termId: 119,
    definition:
      'Number of video ads that were in view and played to 75% of video length. Excludes video ads marked as IVT.',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'Viewable Completed Ads',
    id: 124,
    termId: 120,
    definition:
      'Number of video ads that were in view and played to completion. Excludes video ads marked as IVT.',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'Viewable First Quartile Rate (% of Valid Viewable Video Ads)',
    id: 125,
    termId: 121,
    definition:
      'The percentage of Viewable First Quartile Impressions out of Valid Viewable Video Ads.',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'Viewable Second Quartile Rate (% of Valid Viewable Video Ads)',
    id: 126,
    termId: 122,
    definition:
      'The percentage of Viewable Second Quartile Impressions out of Valid Viewable Video Ads.',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'Viewable Third Quartile Rate (% of Valid Viewable Video Ads) ',
    id: 127,
    termId: 123,
    definition:
      'The percentage of Viewable Third Quartile Impressions out of Valid Viewable Video Ads.',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'Viewable Completion Rate (% of Valid Viewable Video Ads)',
    id: 128,
    termId: 124,
    definition: 'The percentage of Viewable Completed Impressions out of Valid Viewable Video Ads.',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'ON-SCREEN COMPLETES (CTV ONLY)',
    id: 129,
    termId: 125,
    definition: 'The number of video ads that are IVT-free, rendered, and played to completion.',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
  {
    term: 'ON-SCREEN COMPLETION RATE (CTV ONLY)',
    id: 130,
    termId: 126,
    definition:
      'The percentage of impressions that were fraud free, served to certified apps, rendered fully on screen, and played to completion.',
    hierarchy: 1,
    formula: null,
    tag: 'Video',
  },
];

const glossaryGroupM = [
  {
    term: 'Display Viewable Impressions',
    id: 59,
    termId: 59,
    definition:
      'The number of viewable impressions in a campaign where the ad was 100% in view for 1 continuous second. For large ads (242,500 pixels or larger) 50% in view.',
    hierarchy: 1,
    formula: '',
    tag: 'Group M',
  },
  {
    term: 'Display Viewable Rate',
    id: 60,
    termId: 60,
    definition:
      'Percentage of viewable ads where the ad is 100% in view for 1 continuous second. For large ads (242,500 pixels or larger) 50% in view.',
    hierarchy: 1,
    formula: '',
    tag: 'Group M',
  },
  {
    term: 'Video Viewable Ads',
    id: 61,
    termId: 61,
    definition:
      'The number of viewable ads in a campaign where the ad was 100% in view until the video is at least 50% complete or 15 seconds, whichever is less with player audio on for the entire duration. For large ads (242,500 pixels or larger) 80% in view.',
    hierarchy: 1,
    formula: '',
    tag: 'Group M',
  },
  {
    term: 'Video Viewable Rate',
    id: 62,
    termId: 62,
    definition:
      'Percentage of viewable ads where the ad is 100% in view for at least 50% of the video or 15 seconds, whichever is less with audio on for the duration of the ad. For large ads (242,500 pixels or larger) 80% in view.',
    hierarchy: 1,
    formula: '',
    tag: 'Group M',
  },
  {
    term: 'Billable Ads',
    id: 63,
    termId: 63,
    definition: 'Number of ads that have met the requirements for billing.',
    hierarchy: 1,
    formula: '',
    tag: 'Group M',
  },
];

const glossaryPublicis = [
  {
    term: 'Display Viewable Rate',
    id: 64,
    termId: 60,
    definition:
      'Percentage of viewable ads where the ad is 100% in view for 1 continuous second. For large ads (242,500 pixels or larger) 30% in view.',
    hierarchy: 2,
    formula: null,
    tag: 'Publicis',
  },
  {
    term: 'Display Viewable Impressions',
    id: 65,
    termId: 59,
    definition:
      'Number of viewable impressions where the ad is 100% in view for 1 continuous second. For large ads (242,500 pixels or larger) 30% in view.',
    hierarchy: 2,
    formula: null,
    tag: 'Publicis',
  },
  {
    term: 'Video Viewable Rate',
    id: 66,
    termId: 62,
    definition:
      'Percentage of viewable ads where the ad is 100% in view for 2 continuous seconds. For large ads (242,500 pixels or larger) 50% in view.',
    hierarchy: 2,
    formula: null,
    tag: 'Publicis',
  },
  {
    term: 'Video Viewable Impressions',
    id: 67,
    termId: 61,
    definition:
      'Number of viewable impressions where the ad is 100% in view for 2 continuous seconds. For large ads (242,500 pixels or larger) 50% in view.',
    hierarchy: 2,
    formula: null,
    tag: 'Publicis',
  },
];

const glossaryBlockedReasons = [
  {
    term: 'BLOCKED BY ADWARE',
    id: 137,
    termId: 137,
    definition: 'Number of ads that were blocked due to adware.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Reasons',
  },
  {
    term: 'Passed Ads',
    id: 31,
    termId: 31,
    definition: 'Number of ads that align with firewall parameters.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Reasons',
  },
  {
    term: '% Passed Ads',
    id: 32,
    termId: 32,
    definition:
      'Percentage of ads that meet campaign parameters. Passed ads column divided by total ads column.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Reasons',
  },
  {
    term: 'Failed Ads',
    id: 33,
    termId: 33,
    definition:
      'The number of ads that do not align with campaign parameters for invalid traffic, brand safety, custom keywords, custom URL, geo, invisible URL or target language. These ads may or may not be blocked.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Reasons',
  },
  {
    term: '% Failed Ads',
    id: 34,
    termId: 34,
    definition:
      'Percentage of ads that do not align with campaign parameters. Failed ads column divided by total ads column.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Reasons',
  },
  {
    term: '% Failed to Block',
    id: 35,
    termId: 35,
    definition:
      'Percentage of ads that IAS failed to block that did not meet Brand Safety requirements.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Reasons',
  },
  {
    term: 'Blocked by brand safety ',
    id: 37,
    termId: 37,
    definition:
      "Number of ads blocked due to failing the IAS advertisers' brand safety risk thresholds.",
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Reasons',
  },
  {
    term: 'Blocked by custom URL/App exclusion list',
    id: 38,
    termId: 38,
    definition:
      'Number of ads blocked from sites that are a part of a custom list provided by the IAS advertiser.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Reasons',
  },
  {
    term: 'Blocked by geo',
    id: 39,
    termId: 39,
    definition:
      'Number of ads blocked due to being outside the Geo targeting requested by the IAS advertiser.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Reasons',
  },
  {
    term: 'Blocked by custom keyword exclusion list',
    id: 40,
    termId: 40,
    definition:
      'Number of ads blocked because a URL had a keyword marked for exclusion by the IAS advertiser.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Reasons',
  },
  {
    term: 'Blocked by invisible URL',
    id: 41,
    termId: 41,
    definition:
      'Number of ads blocked because IAS could not identify the page where the ad was serving. ',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Reasons',
  },
  {
    term: 'Blocked by Invalid Traffic',
    id: 43,
    termId: 43,
    definition:
      'Number of ads blocked because the page on which the ad was serving is identified as invalid traffic.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Reasons',
  },
  {
    term: 'Blocked by target language mismatch',
    id: 85,
    termId: 80,
    definition:
      'Number of ads blocked due to the language not matching the language requested by the IAS advertiser.',
    hierarchy: 1,
    formula: null,
    tag: 'Blocked Reasons',
  },
  {
    term: 'Blocked by brand suitability',
    id: 92,
    termId: 88,
    definition: "Number of ads blocked for the IAS advertiser's brand suitability segments.",
    hierarchy: 1,
    formula: null,
    tag: 'Blocked Reasons',
  },
  {
    term: 'Blocked Rate',
    id: 9,
    termId: 9,
    definition: 'Percentage of ads blocked for brand safety reasons.',
    hierarchy: 1,
    formula: '[SUM(blockedImps) / SUM(totalImps)) * 100]',
    tag: 'Blocked Reasons',
  },
];

const glossaryBlockedRiskCategories = [
  {
    term: 'Blocked adult ads',
    id: 44,
    termId: 44,
    definition:
      'Number of blocked ads on web pages that contained descriptions, images, and videos of adult topics.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Risk Categories',
  },
  {
    term: 'Blocked alcohol ads',
    id: 45,
    termId: 45,
    definition:
      'Number of blocked ads on web pages that contained representations and endorsements/glorification of alcohol consumption and/or abuse.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Risk Categories',
  },
  {
    term: 'Blocked illegal downloads ads',
    id: 46,
    termId: 46,
    definition:
      'Number of blocked ads on web pages that offered illegal viewing or download of copyrighted content (movies, music, games, software, etc), including illegal links to copyrighted content.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Risk Categories',
  },
  {
    term: 'Blocked drugs ads',
    id: 47,
    termId: 47,
    definition:
      'Number of blocked ads on web pages that contained representations and endorsements/glorification of illegal drugs and prescription drugs that are illegally bought, sold, and traded.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Risk Categories',
  },
  {
    term: 'Blocked hate speech ads',
    id: 48,
    termId: 48,
    definition:
      'Number of blocked ads on web pages that promoted discrimination, denigration and aggression towards people or groups based on race, religion, gender, nationality, and ethnicity.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Risk Categories',
  },
  {
    term: 'Blocked offensive language ads',
    id: 49,
    termId: 49,
    definition:
      'Number of blocked ads on web pages that contained offensive terms: insults, swear words, vulgar terms, and religious blasphemy.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Risk Categories',
  },
  {
    term: 'Blocked violence ads',
    id: 50,
    termId: 50,
    definition:
      'Number of blocked ads on web pages that contained representations and endorsements/glorification of violence.',
    hierarchy: 1,
    formula: '',
    tag: 'Blocked Risk Categories',
  },
];

const glossaryExposure = [
  {
    term: 'In View at Page Open',
    id: 15,
    termId: 15,
    definition:
      'Extrapolation to determine the % of ads that are in view at the time the user opens a web page.',
    hierarchy: 1,
    formula: '',
    tag: 'Exposure',
  },
  {
    term: 'In View > 5 sec',
    id: 16,
    termId: 16,
    definition:
      'Extrapolation to determine the % of the ads in a campaign that are in view for a continuous time of more than five seconds.',
    hierarchy: 1,
    formula: '',
    tag: 'Exposure',
  },
  {
    term: 'In View > 15 sec',
    id: 17,
    termId: 17,
    definition:
      'Extrapolation to determine the % of the ads in a campaign that are in view for a continuous time of more than 15 seconds.',
    hierarchy: 1,
    formula: '',
    tag: 'Exposure',
  },
  {
    term: 'Out of View',
    id: 138,
    termId: 138,
    definition:
      'Number of ads in a campaign with all invalid traffic removed that did not meet the viewability requirements.',
    hierarchy: 1,
    formula: '',
    tag: 'Exposure',
  },
  {
    term: 'Average Time in View (secs) (hours)',
    id: 18,
    termId: 18,
    definition: 'The average time that at least 50% of the ad was in view for a campaign.',
    hierarchy: 1,
    formula: '',
    tag: 'Exposure',
  },
  {
    term: 'Total Time in View',
    id: 19,
    termId: 19,
    definition: 'The amount of time in hours an ad is in view for a campaign.',
    hierarchy: 1,
    formula: '',
    tag: 'Exposure',
  },
  {
    term: 'Fully In View',
    id: 20,
    termId: 20,
    definition:
      'Percentage of viewable ads in a campaign where 100% of the ad is in view for any amount of time.',
    hierarchy: 1,
    formula: '',
    tag: 'Exposure',
  },
  {
    term: 'Average Time on Page (secs)',
    id: 21,
    termId: 21,
    definition: 'The average time a user is on a page during a campaign.',
    hierarchy: 1,
    formula: '',
    tag: 'Exposure',
  },
  {
    term: 'Never in View',
    id: 23,
    termId: 23,
    definition: 'Extrapolation to determine the % of the ads that are never in view (0 seconds).',
    hierarchy: 1,
    formula: '',
    tag: 'Exposure',
  },
];

const glossaryOutOfViewReasons = [
  {
    term: 'Not enough time',
    id: 68,
    termId: 64,
    definition: 'Number of ads that were in view for less than 1 sec (MRC standard).',
    hierarchy: 1,
    formula: null,
    tag: 'Out of View Reasons',
  },
  {
    term: 'Not enough pixels',
    id: 69,
    termId: 65,
    definition: 'Number of ads where less than 50% of the pixels are in view (MRC standard).',
    hierarchy: 1,
    formula: null,
    tag: 'Out of View Reasons',
  },
  {
    term: 'Never on screen',
    id: 70,
    termId: 66,
    definition: 'Number of ads where the ad is never in view.',
    hierarchy: 1,
    formula: null,
    tag: 'Out of View Reasons',
  },
  {
    term: 'Out of focus',
    id: 71,
    termId: 67,
    definition: 'Number of ads where the tab is hidden or the browser window is minimized.',
    hierarchy: 1,
    formula: null,
    tag: 'Out of View Reasons',
  },
  {
    term: 'Video Never Started',
    id: 88,
    termId: 83,
    definition: 'Number of video ads where an ad loaded but never started.',
    hierarchy: 1,
    formula: null,
    tag: 'Out of View Reasons',
  },
];

const glossaryFailureReasons = [
  {
    term: 'Failed for brand safety',
    id: 93,
    termId: 89,
    definition:
      "Number of ads marked as failed for the IAS advertisers' brand safety risk thresholds.",
    hierarchy: 1,
    formula: null,
    tag: 'Failure Reasons',
  },
  {
    term: 'Failed for brand suitability',
    id: 94,
    termId: 90,
    definition:
      "Number of ads marked as failed for the IAS advertiser's brand suitability segments.",
    hierarchy: 1,
    formula: null,
    tag: 'Failure Reasons',
  },
  {
    term: 'Failed for custom keyword exclusion list',
    id: 95,
    termId: 91,
    definition:
      'Number of ads marked as failed because a URL had a keyword marked for exclusion by the IAS advertiser.',
    hierarchy: 1,
    formula: null,
    tag: 'Failure Reasons',
  },
  {
    term: 'Failed for custom URL/App exclusion list',
    id: 96,
    termId: 92,
    definition:
      'Number of ads marked as failed from sites that are in a custom list provided by the IAS advertiser.',
    hierarchy: 1,
    formula: null,
    tag: 'Failure Reasons',
  },
  {
    term: 'Failed for geo',
    id: 97,
    termId: 93,
    definition:
      'Number of ads marked as failed due to being outside the Geo targeting requested by the IAS advertiser.',
    hierarchy: 1,
    formula: null,
    tag: 'Failure Reasons',
  },
  {
    term: 'Failed for invalid traffic ',
    id: 98,
    termId: 94,
    definition:
      'Number of ads marked as failed because the page on which the ad was serving is identified as invalid traffic.',
    hierarchy: 1,
    formula: null,
    tag: 'Failure Reasons',
  },
  {
    term: 'Failed for invisible URL',
    id: 99,
    termId: 95,
    definition:
      'Number of ads marked as failed because IAS could not identify the page where the ad was serving. ',
    hierarchy: 1,
    formula: null,
    tag: 'Failure Reasons',
  },
  {
    term: 'Failed for target language mismatch ',
    id: 100,
    termId: 96,
    definition:
      'Number of ads marked as failed due to the language not matching the language requested by the IAS advertiser.',
    hierarchy: 1,
    formula: null,
    tag: 'Failure Reasons',
  },
];

const glossaryFailureRiskCategories = [
  {
    term: 'Failed adult ads',
    id: 101,
    termId: 97,
    definition:
      'Number of failed ads on web pages that contained descriptions, images, and videos of adult topics.',
    hierarchy: 1,
    formula: null,
    tag: 'Failure Risk Categories',
  },
  {
    term: 'Failed alcohol ads',
    id: 102,
    termId: 98,
    definition:
      'Number of failed ads on web pages that contained representations and endorsements/glorification of alcohol consumption and/or abuse.',
    hierarchy: 1,
    formula: null,
    tag: 'Failure Risk Categories',
  },
  {
    term: 'Failed hate speech ads',
    id: 103,
    termId: 99,
    definition:
      'Number of failed ads on web pages that promoted discrimination, denigration and aggression towards people or groups based on race, religion, gender, nationality, and ethnicity.',
    hierarchy: 1,
    formula: null,
    tag: 'Failure Risk Categories',
  },
  {
    term: 'Failed illegal downloads ads',
    id: 104,
    termId: 100,
    definition:
      'Number of failed ads on web pages that offered illegal viewing or download of copyrighted content (movies, music, games, software, etc), including illegal links to copyrighted content.',
    hierarchy: 1,
    formula: null,
    tag: 'Failure Risk Categories',
  },
  {
    term: 'Failed drugs ads',
    id: 105,
    termId: 101,
    definition:
      'Number of failed ads on web pages that contained representations and endorsements/glorification of illegal drugs and prescription drugs that are illegally bought, sold, and traded.',
    hierarchy: 1,
    formula: null,
    tag: 'Failure Risk Categories',
  },
  {
    term: 'Failed offensive language ads',
    id: 106,
    termId: 102,
    definition:
      'Number of failed ads on web pages that contained offensive terms: insults, swear words, vulgar terms, and religious blasphemy.',
    hierarchy: 1,
    formula: null,
    tag: 'Failure Risk Categories',
  },
  {
    term: 'Failed violence ads',
    id: 107,
    termId: 103,
    definition:
      'Number of failed ads on web pages that contained representations and endorsements/glorification of violence.',
    hierarchy: 1,
    formula: null,
    tag: 'Failure Risk Categories',
  },
];

const glossaryContentSegments = [
  {
    term: 'GARM',
    id: 132,
    termId: 128,
    definition:
      'All GARM segments that are associated with the content present on the stated publisher web page. Segments are displayed as values separated by two pipes: "||".',
    hierarchy: 1,
    formula: null,
    tag: 'Content Segments',
  },
  {
    term: 'Avoidance',
    id: 133,
    termId: 129,
    definition:
      'All avoidance segments that are associated with the content present on the stated publisher web page. Segments are displayed as values separated by two pipes: "||". Note: Avoidance is only available to publishers who have opted for it.',
    hierarchy: 1,
    formula: null,
    tag: 'Content Segments',
  },
  {
    term: 'Targeting',
    id: 134,
    termId: 130,
    definition:
      'All targeting segments that are associated with the content present on the stated publisher web page. Segments are displayed as values separated by two pipes: "||".Note: Targeting is only available to publishers who have opted for it.',
    hierarchy: 1,
    formula: null,
    tag: 'Content Segments',
  },
];

export const IASGlossaryRaw = [
  {
    header: 'Ads',
    contents: glossaryAds,
  },
  {
    header: 'Rates',
    contents: glossaryRates,
  },
  {
    header: 'Invalid Traffic',
    contents: glossaryInvalidTraffic,
  },
  {
    header: 'Bots',
    contents: glossaryBots,
  },
  {
    header: 'Video',
    contents: glossaryVideo,
  },
  {
    header: 'Group M',
    contents: glossaryGroupM,
  },
  {
    header: 'Publicis',
    contents: glossaryPublicis,
  },
  {
    header: 'Blocked Reasons',
    contents: glossaryBlockedReasons,
  },
  {
    header: 'Blocked Risk Categories',
    contents: glossaryBlockedRiskCategories,
  },
  {
    header: 'Exposure',
    contents: glossaryExposure,
  },
  {
    header: 'Out of View Reasons',
    contents: glossaryOutOfViewReasons,
  },
  {
    header: 'Failure Reasons',
    contents: glossaryFailureReasons,
  },
  {
    header: 'Failure Risk Categories',
    contents: glossaryFailureRiskCategories,
  },
  {
    header: 'Content Segments',
    contents: glossaryContentSegments,
  },
];
